/**
 * Device Token utility for device binding (vincolo dispositivo).
 * Generates a unique token per browser/device and persists it
 * in BOTH localStorage AND a cookie for maximum persistence.
 * Mobile Safari can clear localStorage — the cookie acts as backup.
 */

const DEVICE_TOKEN_KEY = "yollo_device_token";
const COOKIE_NAME = "yollo_device_token";
const COOKIE_MAX_AGE = 365 * 24 * 60 * 60; // 1 anno

function getCookie(name) {
  const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  return match ? decodeURIComponent(match[2]) : null;
}

function setCookie(name, value) {
  document.cookie = `${name}=${encodeURIComponent(value)};path=/;max-age=${COOKIE_MAX_AGE};SameSite=Lax`;
}

function generateUUID() {
  if (crypto.randomUUID) return crypto.randomUUID();
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export function getDeviceToken() {
  // 1. Prova localStorage
  let token = localStorage.getItem(DEVICE_TOKEN_KEY);

  if (token) {
    // Sincronizza col cookie
    setCookie(COOKIE_NAME, token);
    return token;
  }

  // 2. Fallback: ripristina dal cookie (localStorage cancellato)
  token = getCookie(COOKIE_NAME);
  if (token) {
    localStorage.setItem(DEVICE_TOKEN_KEY, token);
    return token;
  }

  // 3. Prima volta: genera nuovo token e salva in entrambi
  token = generateUUID();
  localStorage.setItem(DEVICE_TOKEN_KEY, token);
  setCookie(COOKIE_NAME, token);
  return token;
}
